import { Inject, Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';

import * as versionsActions from '../actions/versions.action';
import * as fromRoot from '@usimweb/state/router-store';

import { ApiService } from '@usimweb/core/services';
import { catchError, debounceTime, map, of, switchMap, takeUntil, takeWhile, tap, timer } from 'rxjs';
import { Env, NewVersion, Versions } from '@usimweb/core/models';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Helper } from '@usimweb/core/services';
//import { Disclaimer } from '../../services/application/disclaimer/disclaimer';

@Injectable()
export class VersionsEffects {
  constructor(
    @Inject('environment') private environment: Env,
    private actions$: Actions,
    private apiService: ApiService,
    private snackBar: MatSnackBar //private disclaimer: Disclaimer
  ) {}

  private DEBUG_TIME: number = this.environment.production === true ? 0 : 0;

  $loadVersions = createEffect(() => {
    return this.actions$.pipe(
      ofType(versionsActions.LOAD_VERSIONS),
      map((action: versionsActions.LoadVersions) => action.payload),
      switchMap((uuid: string) => {
        return this.apiService.getVersions(uuid).pipe(
          map((versions: Versions[]) => {
            (versions = versions.filter((x) => {
              if (x.status != undefined) {
                return x.status.simulation !== 'draft';
              }
              return null;
            })).map((x, i) => (x.index = i));

            return new versionsActions.LoadVersionsSuccess(versions);
          }),
          catchError((error) => of(new versionsActions.LoadVersionsFail(error)))
        );
      })
    );
  });

  pollVersions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(versionsActions.POLL_VERSIONS),
      map((action: versionsActions.PollVersions) => action.payload),
      switchMap((uuid: string) => {
        return timer(0, 60000).pipe(
          takeUntil(this.actions$.pipe(ofType(versionsActions.CANCEL_POLLING))),
          switchMap(() => {
            return this.apiService.getVersions(uuid).pipe(
              map((versions) => {
                (versions = versions.filter((x) => {
                  if (x.status.overall != 'draft') {
                    return x;
                  }
                  return null;
                })).map((x, i) => (x.index = i));

                return versions;
              }),
              switchMap((version) => {
                return of(new versionsActions.PollVersionsSuccess(version));
              }),
              catchError((error) => {
                return of(new versionsActions.PollVersionsFail(error));
              })
            );
          })
        );
      })
    );
  });

  createVersion$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(versionsActions.CREATE_VERSION),
      map((action: versionsActions.CreateVersion) => action.payload),
      switchMap((newVersion: NewVersion) => {
        console.log('create version');
        console.log(newVersion);

        if ('input_value' in newVersion) {
          const input_value = newVersion.input_value as any;
          let updatedInputValue = Helper.Array.deepCopy(input_value);

          for (const [key, value] of Object.entries(updatedInputValue)) {
            const obj1 = value as { [key: string]: any };
            for (const [key2] of Object.entries(obj1)) {
              const parts = Array.isArray(updatedInputValue[key]) ? updatedInputValue[key] : [updatedInputValue[key]];
              parts.forEach((part: any) => {
                for (const [key3, value] of Object.entries(part)) {
                  const obj2 = value as { [key: string]: any };
                  if (obj2 && 'default' in obj2) {
                    const value = 'id' in obj2['default'] ? obj2['default'].id : obj2['default'].value;
                    obj2['value'] = value;
                    delete obj2['default'];
                  }
                }
              });
            }
          }
          const updatedNewVersion = { ...newVersion, input_value: updatedInputValue };
          return this.apiService.addProjectVersion(updatedNewVersion).pipe(
            map((newProject) => {
              return new versionsActions.CreateVersionSuccess(newProject);
            }),
            catchError((error) => of(new versionsActions.CreateVersionFail(error)))
          );
        }

        return this.apiService.addProjectVersion(newVersion).pipe(
          map((newProject) => {
            return new versionsActions.CreateVersionSuccess(newProject);
          }),
          catchError((error) => of(new versionsActions.CreateVersionFail(error)))
        );
      })
    );
  });

  getVersion$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(versionsActions.GET_VERSION_BY_ID),
      map((action: versionsActions.GetVersioByid) => action.payload),
      switchMap((uuid: string) => {
        return this.apiService.getVersion(uuid).pipe(
          map((version) => {
            if (version.vela?.input_value) {
              const materials = version.materials;
              const input_value = version.vela.input_value as any;

              for (const [key, value] of Object.entries(materials)) {
                const obj1 = value as { [key: string]: any };

                for (const [key2, nestedArray] of Object.entries(obj1)) {
                  const parts = Array.isArray(input_value[key]) ? input_value[key] : [input_value[key]];
                  parts.forEach((part: any) => {
                    part = 'value' in part ? part : { value: part };

                    part[key2] = {
                      options: [...nestedArray],
                      value: part[key2],
                    };

                    // console.log('part key');
                    // console.log(part);
                    // console.log(part[key2]);
                    // console.log(part[key2].default.value);

                    // if ('options' in part[key2]) {
                    //   part[key2]['default'] = { value: part[key2].default.value };
                    // }
                  });
                }
              }
            }

            console.log('set materials');
            console.log(version);

            return new versionsActions.GetVersioByidSuccess(version);
          }),
          catchError((error) => of(new versionsActions.GetVersioByidFail(error)))
        );
      })
    );
  });

  getNewVersion$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(versionsActions.POLL_VERSION),
      map((action: versionsActions.PollVersion) => action.payload),
      tap(() => (this.isPollingActive = true)),
      switchMap((uuid: string) => {
        return this.apiService.getVersion(uuid).pipe(
          map((version) => {
            //this.isPollingActive = false;
            return new versionsActions.PollVersionSuccess(version);
          }),
          catchError((error) => of(new versionsActions.PollVersionFail(error)))
        );
      })
    );
  });

  private isPollingActive = false;

  pollVersion$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(versionsActions.POLL_VERSION_SUCCESS, versionsActions.POLL_VERSION_FAIL),
      // takeWhile(() => this.isPollingActive),
      map((action: versionsActions.PollVersionSuccess) => action.payload),
      switchMap((version: Versions) => {
        return timer(500, 3000).pipe(
          takeWhile(() => this.isPollingActive),
          switchMap(() => {
            return this.apiService.getVersion(version.uuid).pipe(
              map((version) => {
                if (version.status.overall === 'success') {
                  this.isPollingActive = false;
                }
                if (version.status.overall === 'failed') {
                  this.isPollingActive = false;
                }
                return version;
              }),
              switchMap((version) => {
                //this.isPollingActive = false;
                return of(new versionsActions.PollVersionSuccess(version));
              }),
              catchError((error) => {
                this.isPollingActive = false;
                return of(new versionsActions.PollVersionFail(error));
              })
            );
          })
        );
      })
    );
  });

  $deleteVersion = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(versionsActions.DELETE_VERSION),
        map((action: versionsActions.DeleteVersion) => action.payload),
        switchMap((versions: Versions) => {
          return this.apiService.deleteProjectVersion(versions.uuid).pipe(
            map(() => {
              this.snackBar.open('Deleted version: ' + versions.name, 'OK', { duration: 2000 });
              return new versionsActions.DeleteVersionSuccess(versions);
            }),
            catchError((error) => of(new versionsActions.DeleteVersionFails(error)))
          );
        })
      );
    },
    { dispatch: false }
  );

  // $deleteVersion = createEffect(
  //   () => {
  //     return this.actions$.pipe(
  //       ofType(versionsActions.DELETE_VERSION),
  //       map((action: versionsActions.DeleteVersion) => action.payload),
  //       switchMap((versions: Versions) => {
  //         // map(() => {
  //         //   this.snackBar.open('Deleted version: ' + versions.name, 'OK', { duration: 2000 });
  //         //   return new versionsActions.DeleteVersionSuccess(versions);
  //         // });

  //         console.log('delete version');
  //         console.log(versions);

  //         return of(new versionsActions.DeleteVersionSuccess(versions));
  //       })
  //     );
  //   },
  //   { dispatch: false }
  // );

  $renameVersion = createEffect(() => {
    return this.actions$.pipe(
      ofType(versionsActions.RENAME_VERSION),
      map((action: versionsActions.RenameVersion) => action.payload),
      switchMap((obj: any) => {
        return this.apiService.renameVersion(obj.uuid, obj.name).pipe(
          map((result: any) => {
            this.snackBar.open('Renamed version to : ' + obj.name, 'OK', { duration: 2000 });
            return new versionsActions.RenameVersionSuccess({
              uuid: obj.uuid,
              name: result.name,
              history: result?.history,
            });
          }),
          catchError((error) => of(new versionsActions.RenameVersionFail(error)))
        );
      })
    );
  });

  $backProjects = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(fromRoot.GO),
        map((path) => {
          return new fromRoot.Go({
            path: path,
          });
        })
      );
    },
    { dispatch: false }
  );

  $goNewVersion = createEffect(() => {
    return this.actions$.pipe(
      ofType(versionsActions.GO_NEW_VERSION),
      debounceTime(this.DEBUG_TIME),
      map((action: versionsActions.GoNewVersion) => {
        return new fromRoot.Go({
          path: [action.payload],
        });
      })
    );
  });

  // disclaimerVersion$ = createEffect(
  //   () => {
  //     return this.actions$
  //       .pipe(ofType(versionsActions.LOAD_VERSION_SUCCESS, versionsActions.GET_CURR_VERSION))
  //       .pipe(map(() => this.disclaimer.version()));
  //   },
  //   { dispatch: false }
  // );
}
